import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// When visiting invitations index with ?open_modal=new_invitation (e.g. from billing),
// loads the new-invitation form into invitation_modal so the modal opens in context.
export default class extends Controller {
  static values = {
    newInvitationUrl: String
  }

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("open_modal") !== "new_invitation" || !this.newInvitationUrlValue) {
      return
    }

    this.cleanUrl()
    Turbo.visit(this.newInvitationUrlValue, { frame: "invitation_modal" })
  }

  cleanUrl() {
    const url = new URL(window.location.href)
    url.searchParams.delete("open_modal")
    const clean = url.pathname + (url.search ? url.search : "") + url.hash
    window.history.replaceState(window.history.state, "", clean)
  }
}
